/*
 * Woodenluxe: mega menü hover görseli (24 Ekim 2026, Aşama 1).
 * Alt kategori linkine fare ya da klavye odağı gelince sağdaki görsel o
 * koleksiyonun görseline 300 ms çapraz geçişle değişir. Fare çıkınca son
 * görsel kalır. İki <img> katmanı var; yeni görsel arka katmana yüklenip
 * hazır olunca öne alınır (beyaz yanıp sönme olmaz).
 * Olaylar document üzerinden dinlenir: Dwell header'ı yeniden çizse de çalışır.
 */
const LINK = '[data-wl-mm-link]';
const warmed = new WeakSet();

function warm(root) {
  if (warmed.has(root)) return;
  warmed.add(root);
  const media = root.querySelector('[data-wl-mm-media]');
  const sizes = media?.querySelector('img')?.getAttribute('sizes') || '';
  root.querySelectorAll(LINK).forEach((link) => {
    const img = new Image();
    img.sizes = sizes;
    img.srcset = link.dataset.wlSrcset || '';
    img.src = link.dataset.wlSrc || '';
  });
}

function show(link) {
  const root = link.closest('[data-wl-mm]');
  const media = root?.querySelector('[data-wl-mm-media]');
  if (!root || !media) return;

  root.querySelectorAll(`${LINK}[data-wl-active]`).forEach((el) => el.removeAttribute('data-wl-active'));
  link.setAttribute('data-wl-active', '');

  const href = link.dataset.wlHref;
  if (media.getAttribute('href') === href && !root.dataset.wlPending) return;

  const imgs = media.querySelectorAll('img');
  const front = media.querySelector('img.is-active') || imgs[0];
  const back = Array.from(imgs).find((img) => img !== front);
  if (!back) return;

  const token = String(Date.now() + Math.random());
  root.dataset.wlPending = token;

  back.hidden = false;
  back.alt = link.dataset.wlTitle || '';
  back.srcset = link.dataset.wlSrcset || '';
  back.src = link.dataset.wlSrc || '';

  const done = () => {
    if (root.dataset.wlPending !== token) return; // daha yeni bir hover geldi
    delete root.dataset.wlPending;
    back.classList.add('is-active');
    front.classList.remove('is-active');
    front.alt = '';
    media.setAttribute('href', href);
    const caption = media.querySelector('[data-wl-mm-caption]');
    if (caption) caption.textContent = link.dataset.wlTitle || '';
  };

  if (typeof back.decode === 'function') {
    back.decode().then(done, done);
  } else if (back.complete) {
    done();
  } else {
    back.addEventListener('load', done, { once: true });
    back.addEventListener('error', done, { once: true });
  }
}

document.addEventListener('pointerover', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const root = target.closest('[data-wl-mm]');
  if (!root) return;
  warm(root);
  const link = target.closest(LINK);
  if (link) show(link);
});

document.addEventListener('focusin', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const link = target.closest(LINK);
  if (link) show(link);
});
